import React from "react";
import LogoTextSvg from "assets/icons/logoText.svg";
import NotificationSvg from "assets/icons/notification.svg";
import { HomeHeaderWrapper } from "./HomeHeaderStyle";
import { useNavigate } from "react-router-dom";

const HomeHeader = () => {
  const navigate = useNavigate();
  return (
    <HomeHeaderWrapper>
      <img src={LogoTextSvg} alt="logo" />
      <img
        src={NotificationSvg}
        alt="notification"
        onClick={() => navigate("/alarm")}
        className="notification"
      />
    </HomeHeaderWrapper>
  );
};

export default HomeHeader;
